import { inject, Injectable, DOCUMENT } from '@angular/core';

import { filter, take, tap } from 'rxjs';

import { DomainQuery } from '@common/store/domain.store';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  constructor(private domainQuery: DomainQuery) {}

  private document = inject(DOCUMENT);

  initGTM() {
    this.domainQuery.domain$
      .pipe(
        filter((domain) => !!domain?.config?.gtm?.tag_id),
        take(1),
        tap(() => {
          const gtmTagId = this.domainQuery.getValue().config.gtm?.tag_id;

          if (!gtmTagId) {
            console.warn('GTM tag ID is not set, skipping GTM initialization');
            return;
          }

          (function (w: Window & typeof globalThis, d: Document, s: string, l: string, i: string): void {
            // eslint-disable-next-line
            (w as any)[l] = (w as any)[l] || [];
            // eslint-disable-next-line
            (w as any)[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

            const f = d.getElementsByTagName(s)[0];
            // eslint-disable-next-line
            const j = d.createElement(s) as any;
            j.async = true;
            j.src = `https://www.googletagmanager.com/gtm.js?id=${i}&l=${l}`;
            f.parentNode?.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', gtmTagId);

          // Step 3: Add <noscript> fallback to <body>
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.injectNoScript(gtmTagId));
          } else {
            this.injectNoScript(gtmTagId);
          }

          console.debug('GTM initialized');
        }),
      )
      .subscribe();
  }

  private injectNoScript(gtmId: string): void {
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');

    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }
}
